/**
 * googleAds.js - Safe Google Ads conversion layer.
 *
 * - No-op unless REACT_APP_GOOGLE_ADS_ID and
 *   REACT_APP_GOOGLE_ADS_CONVERSION_LABEL are configured.
 * - Never throws into product flows.
 * - Does not send email, user id, or other PII to Google Ads.
 */

const PUBLIC_GOOGLE_ADS_ID = 'AW-18363268164';
const PUBLIC_REGISTRATION_LABEL = 'YsOCCIn3gtocEMT4pLRE';

const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || PUBLIC_GOOGLE_ADS_ID;
const REGISTRATION_LABEL =
  process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || PUBLIC_REGISTRATION_LABEL;

function hasValidValue(value) {
  return !!value && value !== 'undefined' && !value.startsWith('%');
}

export function hasGoogleAdsConfig() {
  return hasValidValue(ADS_ID);
}

export function getGoogleAdsId() {
  return ADS_ID;
}

export function hasGoogleAdsRegistrationConfig() {
  return hasValidValue(ADS_ID) && hasValidValue(REGISTRATION_LABEL);
}

function logEvent(name, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (!window.__googleAdsEvents) window.__googleAdsEvents = [];
    window.__googleAdsEvents.push({ name, params, ts: new Date().toISOString() });
  } catch (_) {}
}

export function trackGoogleAdsRegistration() {
  try {
    if (!hasGoogleAdsRegistrationConfig()) {
      logEvent('GoogleAdsRegistrationSkipped', { reason: 'missing_config' });
      return;
    }

    const gtag = typeof window !== 'undefined' ? window.gtag : null;
    if (typeof gtag !== 'function') {
      logEvent('GoogleAdsRegistrationSkipped', { reason: 'gtag_unavailable' });
      return;
    }

    const params = {
      send_to: `${ADS_ID}/${REGISTRATION_LABEL}`,
      value: 0,
      currency: 'USD',
    };

    gtag('event', 'conversion', params);
    logEvent('GoogleAdsRegistration', { send_to: params.send_to, value: 0, currency: 'USD' });
  } catch (_) {}
}
